import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
// import rows from "./data/TableData";
import { FormControlLabel, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import { getRentData } from "../../services/rent.service";
import { Box } from "@mui/system";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import "./AllStoresPage.scss";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

const AllStoresPage = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [age, setAge] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [selectedDate1, setSelectedDate1] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [selectedDate3, setSelectedDate3] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedValue, setSelectedValue] = React.useState("e");
  const [rows, setRows] = useState([]);

  console.log("rows", rows);

  useEffect(() => {
    getRentData().then((res) => {
      console.log(res);
      const rentDataRes = res.data.rent;
      setRows(rentDataRes);
    });
  }, []);

  const isValidDate = (date) => date !== null && dayjs(date).isValid();

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "size-radio-button-demo",
    inputProps: { "aria-label": item },
  });

  useEffect(() => {
    if (selectedValue !== "a") {
      setSelectedDate1(null);
    }
    if (selectedValue !== "b") {
      setSelectedDate2(null);
    }
    if (selectedValue !== "c") {
      setSelectedDate3(null);
    }
    if (selectedValue !== "d") {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }
  }, [selectedValue]);

  const handleDateChange1 = (newDate) => {
    setSelectedDate1(newDate);
  };

  const handleDateChange2 = (newDate) => {
    setSelectedDate2(newDate);
  };

  const handleDateChange3 = (newDate) => {
    setSelectedDate3(newDate);
  };

  const handleStartDateChange = (newDate) => {
    setSelectedStartDate(newDate);
  };

  const handleEndDateChange = (newDate) => {
    setSelectedEndDate(newDate);
  };

  const rowsFiltered = rows.filter((row) => {
    if (selectedValue === "e") {
      return true;
    }

    let rentalStatusFilter = false;

    if (selectedValue === "tambon1" && row.RentalStatus === "1") {
      rentalStatusFilter = true;
    } else if (selectedValue === "tambon2" && row.RentalStatus === "0") {
      rentalStatusFilter = true;
    } else if (selectedValue === "tambon3") {
      rentalStatusFilter = true;
    }

    if (
      selectedValue === "a" ||
      selectedValue === "b" ||
      selectedValue === "c" ||
      selectedValue === "d"
    ) {
      const startDate = dayjs(row.RentalDate, "DD/MM/YYYY");

      const dayFilter =
        selectedValue === "a" &&
        isValidDate(selectedDate1) &&
        startDate.date() === selectedDate1.date() &&
        startDate.month() === selectedDate1.month() &&
        startDate.year() === selectedDate1.year();
      const monthFilter =
        selectedValue === "b" &&
        isValidDate(selectedDate2) &&
        startDate.month() === selectedDate2.month() &&
        startDate.year() === selectedDate2.year();
      const yearFilter =
        selectedValue === "c" &&
        isValidDate(selectedDate3) &&
        startDate.year() === selectedDate3.year();
      const dateRangeFilter =
        selectedValue === "d" &&
        isValidDate(selectedStartDate) &&
        isValidDate(selectedEndDate) &&
        dayjs(selectedStartDate).isBefore(startDate) &&
        dayjs(selectedEndDate).isAfter(startDate);

      const dateFilter =
        dayFilter || monthFilter || yearFilter || dateRangeFilter;

      return dateFilter;
    }

    if (
      (age === "" || row.Zone === age) &&
      (row.BlockNumber.includes(searchInput) ||
        row.tenantName.includes(searchInput)) &&
      rentalStatusFilter
    ) {
      return true;
    } else {
      return false;
    }
  });

  const rowsFilteredSorted = rowsFiltered.sort((a, b) => {
    if (a.zone_name < b.zone_name) {
      return -1;
    }
    if (a.zone_name > b.zone_name) {
      return 1;
    }

    const getBlockNumber = (blockNumber) => {
      const match = blockNumber.match(/(\d+)/);
      return match ? parseInt(match[0], 10) : 0;
    };

    const aBlockNumber = getBlockNumber(a.BlockNumber);
    const bBlockNumber = getBlockNumber(b.BlockNumber);

    return aBlockNumber - bBlockNumber;
  });

  console.log("selectedValue Ta", selectedValue);

  const handleOpen = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const searchSupplier = (e) => {
    setSearchInput(e.target.value);
    setSelectedValue("tambon3");
  };

  const columns = [
    // {
    //   field: "ImgShop",
    //   headerName: "ภาพหน้าร้าน",
    //   width: 120,
    //   renderCell: (params) => (
    //     <img
    //       src={params.value}
    //       alt="Shop"
    //       style={{
    //         width: 50,
    //         borderRadius: "0.375rem",
    //         width: "59px",
    //         height: "59px",
    //       }}
    //       onClick={() => handleOpen(params.value)}
    //     />
    //   ),
    // },
    // {
    //   field: "RentalShopName",
    //   headerName: "ชื่อร้านที่เช่า",
    //   sortable: false,
    //   width: isHovered ? 290 : 120,
    //   renderCell: (params) => (
    //     <div
    //       style={{ paddingLeft: "0" }}
    //       onMouseEnter={() => setIsHovered(true)}
    //       onMouseLeave={() => setIsHovered(false)}
    //     >
    //       <p>{params.value}</p>
    //     </div>
    //   ),
    // },
    {
      field: "tenantName",
      headerName: "ชื่อผู้เช่าร้าน",
      sortable: false,
      width: isHovered ? 200 : 135,
      renderCell: (params) => (
        <div
          style={{ paddingLeft: "0" }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <p>{params.value}</p>
        </div>
      ),
    },
    {
      field: "tenant_nickname",
      headerName: "เบอร์ติดต่อ (TH)",
      sortable: false,
      width: 135,
    },
    {
      field: "tenant_phone",
      headerName: "เบอร์ติดต่อ (KH)",
      sortable: false,
      width: 135,
    },
    {
      field: "RentalDate",
      headerName: "วันที่เริ่มเช่า",
      sortable: false,
      width: 135,
    },
    {
      field: "Endrent",
      headerName: "วันที่จ่ายล่าสุด",
      sortable: false,
      width: 135,
      valueFormatter: (params) => {
        if (params.value == null) {
          return "--/--/--";
        }
        return params.value;
      },
    },
    {
      field: "BlockNumber",
      headerName: "บล็อกที่อยู่",
      sortable: false,
      width: 135,
    },
    {
      field: "TentDeposit",
      headerName: "ค่ามัดจำเต็นท์",
      width: 135,
      sortable: false,
      valueFormatter: (params) => {
        if (params.value == null) {
          return "";
        }
        return new Intl.NumberFormat("th-TH", {
          maximumFractionDigits: 0,
        }).format(params.value);
      },
    },
    {
      field: "Deposit",
      headerName: "ค่ามัดจำ",
      width: 135,
      valueFormatter: (params) => {
        if (params.value == null) {
          return "";
        }
        return new Intl.NumberFormat("th-TH", {
          maximumFractionDigits: 0,
        }).format(params.value);
      },
    },
    {
      field: "Rent",
      headerName: "ค่าเช่า",
      width: 135,
      valueFormatter: (params) => {
        if (params.value == null) {
          return "";
        }
        return new Intl.NumberFormat("th-TH", {
          maximumFractionDigits: 0,
        }).format(params.value);
      },
    },
    // {
    //   field: "ElectricityBill",
    //   headerName: "ค่าไฟ/เดือน",
    //   width: 125,
    //   valueFormatter: (params) => {
    //     if (params.value == null) {
    //       return "";
    //     }
    //     return new Intl.NumberFormat("th-TH", {
    //       maximumFractionDigits: 0,
    //     }).format(params.value);
    //   },
    // },

    {
      field: "Overdue",
      headerName: "ค่าเช่าค้างจ่าย",
      width: 135,
      valueFormatter: (params) => {
        if (params.value == null) {
          return "";
        }
        return new Intl.NumberFormat("th-TH", {
          maximumFractionDigits: 0,
        }).format(params.value);
      },
    },
    {
      field: "Fine",
      headerName: "ค่าปรับ",
      width: 125,
      valueFormatter: (params) => {
        if (params.value == null) {
          return "----฿";
        }
        return new Intl.NumberFormat("th-TH", {
          maximumFractionDigits: 0,
        }).format(params.value);
      },
    },
    {
      field: "RentalStatus",
      headerName: "สถานะการเช่า",
      width: 135,
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            color: params.row.RentalStatus === "1" ? "#00D715" : "#FF2C2C",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          {params.row.RentalStatus === "1" ? "ยังเช่าอยู่" : "ย้ายออกแล้ว"}
          <p
            style={{
              fontSize: "12px",
              lineHeight: "12.5px",
              color: "#9993B4",
              textAlign: "center",
            }}
          >
            06/09/2023
          </p>
        </div>
      ),
    },
  ];

  const zones = Array.from(new Set(rows.map((row) => row.Zone)));

  const zoneOptions = zones.map((zone, index) => (
    <MenuItem key={index} value={zone}>
      {zone}
    </MenuItem>
  ));

  const totals = rowsFiltered.reduce(
    (accumulator, row) => {
      accumulator.totalDeposit += row.Deposit || 0;
      accumulator.totalRent += row.Rent || 0;
      accumulator.totalWaterBill += row.WaterBill || 0;
      accumulator.totalElectricityBill += row.ElectricityBill || 0;
      accumulator.totalTotal += row.Overdue || 0;
      accumulator.totalFine += row.Fine || 0;
      return accumulator;
    },
    {
      totalDeposit: 0,
      totalRent: 0,
      totalWaterBill: 0,
      totalElectricityBill: 0,
      totalTotal: 0,
      totalFine: 0,
    }
  );

  const {
    totalDeposit,
    totalRent,
    totalWaterBill,
    totalElectricityBill,
    totalTotal,
    totalFine,
  } = totals;

  const formattedTotalDeposit = totalDeposit.toLocaleString();
  const formattedTotalRent = totalRent.toLocaleString();
  const formattedTotalElectricityBill = totalElectricityBill.toLocaleString();
  const formattedTotalMoney = totalTotal.toLocaleString();
  const formattedTotalFine = totalFine.toLocaleString();

  const totalAll =
    totalDeposit +
    totalRent +
    totalWaterBill +
    totalElectricityBill +
    totalTotal +
    totalFine;
  const formattedTotalAll = totalAll.toLocaleString();
  const dataTotal = [
    { p: "ค่ามัดจำ : ", price: formattedTotalDeposit || 0 },
    { p: "ค่าเช่า : ", price: formattedTotalRent || 0 },
    // { p: "ค่าไฟ/เดือน : ", price: formattedTotalElectricityBill },
    { p: "ค่าเช่าค้างจ่าย :", price: formattedTotalMoney || 0 },
    { p: "ค่าปรับ : ", price: formattedTotalFine || 0},
    { p: "ยอดรวมทั้งหมด : ", price: formattedTotalAll || 0},
  ];

  const totalData = dataTotal.map((item, index) => (
    <div key={index} className="total-Data">
      <p className="title-total">{item.p}</p>
      <p className="price-total">{item.price} ฿</p>
    </div>
  ));

  const exportToExcel = () => {
    const headers = {
      // ภาพหน้าร้าน: "ImgShop",
      // ชื่อร้านที่เช่า: "RentalShopName",
      ชื่อผู้เช่าร้าน: "tenantName",
      เบอร์ติดต่อTH: "tenant_nickname",
      เบอร์ติดต่อKH: "tenant_phone",
      วันที่เริ่มเช่า: "RentalDate",
      วันที่จ่ายล่าสุด: "Endrent",
      บล็อกที่อยู่: "BlockNumber",
      ค่ามัดจำเต็นท์: "TentDeposit",
      ค่ามัดจำ: "Deposit",
      ค่าเช่า: "Rent",
      // ค่าไฟต่อเดือน: "ElectricityBill",
      ค่าเช่าค้างจ่าย: "Overdue",
      ค่าปรับ: "Fine",
      // สถานะการเช่า: "RentalStatus",
    };

    const mappedRows = rowsFiltered.map((row) => {
      const mappedRow = {};
      for (const key in headers) {
        mappedRow[key] = row[headers[key]];
      }
      return mappedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(mappedRows);
    XLSX.utils.sheet_add_aoa(worksheet, [[...Object.keys(headers)]], {
      origin: "A1",
    });

    const dataTotal = [
      { p: "" },
      { p: "ผลรวมค่าต่างๆ" },
      { p: "ค่ามัดจำ : ", price: formattedTotalDeposit },
      { p: "ค่าเช่า : ", price: formattedTotalRent },
      // { p: "ค่าไฟ/เดือน : ", price: formattedTotalElectricityBill },
      { p: "ค่าเช่าค้างจ่าย :", price: formattedTotalMoney },
      { p: "ค่าปรับ : ", price: formattedTotalFine },
      { p: "ยอดรวมทั้งหมด : ", price: formattedTotalAll },
    ];

    const dataTotalRows = dataTotal.map((item) => [item.p, item.price]);
    XLSX.utils.sheet_add_aoa(worksheet, dataTotalRows, {
      origin: "A" + (mappedRows.length + 2),
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "FilteredData");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "FilteredData.xlsx");
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="header">
        <div style={{ fontSize: "1.75rem", fontWeight: 500 }}>
          รายงานทั้งหมด
        </div>
        <div className="search">
          <TextField
            label="ค้นหา บล็อก,ชื่อ"
            id="outlined-size-small"
            size="small"
            style={{ width: "230px" }}
            onChange={(e) => searchSupplier(e)}
            InputProps={{
              endAdornment: <SearchIcon style={{ color: "grey" }} />,
            }}
          />
        </div>
      </div>

      <div className="from-AllStore">
        {/* บล็อกด้านขวา */}
        <div className="from-filter1">
          <div className="button-text">
            <p style={{ fontWeight: 700, fontSize: "18px" }}>เลือก</p>
            <Button
              variant="contained"
              size="small"
              style={{
                fontSize: "14px",
                background: "#6C5DD3",
                color: "white",
                height: "39px",
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
                // marginTop: "2rem",
              }}
              className="button-h"
              onClick={exportToExcel}
            >
              Export to Excel
            </Button>
          </div>

          <div className="from-Date-filter1">
            {/* <div className="date-1">
              <Radio {...controlProps("a")} />
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  minWidth: "36px",
                }}
              >
                วัน
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="วัน"
                  inputFormat="DD-MM-YYYY"
                  disabled={selectedValue !== "a"}
                  value={selectedDate1}
                  onChange={handleDateChange1}
                  views={["day", "month", "year"]}
                  sx={{ width: "33.33%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ width: "100%" }}
                      size="small"
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                      }}
                      style={{ width: "100%" }}
                      required
                    />
                  )}
                />
              </LocalizationProvider>
            </div> */}
            <div className="date-2">
              <Radio {...controlProps("b")} />
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  minWidth: "36px",
                }}
              >
                เดือน
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="เดือน"
                  inputFormat="MM-YYYY"
                  views={["month", "year"]}
                  disabled={selectedValue !== "b"}
                  value={selectedDate2}
                  onChange={handleDateChange2}
                  sx={{ width: "33.33%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ width: "100%" }}
                      size="small"
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                      }}
                      required
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
            <div className="date-3">
              <Radio {...controlProps("c")} />
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  minWidth: "36px",
                }}
              >
                ปี
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="ปี"
                  inputFormat="YYYY"
                  views={["year"]}
                  disabled={selectedValue !== "c"}
                  value={selectedDate3}
                  onChange={handleDateChange3}
                  sx={{ width: "33.33%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ width: "100%" }}
                      size="small"
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                      }}
                      required
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
            <div className="date-4">
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "100%" }}
              >
                <InputLabel id="select-label-tambon">สถานะการเช่า</InputLabel>
                <Select
                  labelId="select-label-tambon"
                  id="select-tambon"
                  label="สถานะการจ่าย"
                  value={selectedValue}
                  onChange={handleChange}
                >
                  <MenuItem value="tambon1">เช่าอยู่</MenuItem>
                  <MenuItem value="tambon2">ย้ายออก</MenuItem>
                  <MenuItem value="tambon3">ทั้งหมด</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="date-5">
              <Radio {...controlProps("d")} />
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  minWidth: "36px",
                }}
              >
                ตั้งแต่
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="ตั้งแต่"
                  inputFormat="MM-YYYY"
                  views={["month", "year"]}
                  disabled={selectedValue !== "d"}
                  value={selectedStartDate}
                  onChange={handleStartDateChange}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ width: "100%" }}
                      size="small"
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                      }}
                      required
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
            <div className="date-6">
              <p
                className="date-2-text"
                style={{
                  fontWeight: 400,
                  fontSize: "16px",
                  marginRight: "19px",
                }}
              >
                จนถึง
              </p>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="จนถึง"
                  inputFormat="MM-YYYY"
                  views={["month", "year"]}
                  disabled={selectedValue !== "d"}
                  value={selectedEndDate}
                  onChange={handleEndDateChange}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ width: "100%" }}
                      size="small"
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                      }}
                      required
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
            <div className="date-5">
              <Radio {...controlProps("e")} />
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  minWidth: "36px",
                }}
              >
                ทั้งหมด
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="data-box1">{totalData}</div>

      <DataGrid
        rows={rowsFiltered}
        columns={columns}
        rowHeight={70}
        rowsPerPageOptions={[5]}
        className="custom-data-grid"
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <img
            src={selectedImage}
            alt="Zoomed Shop"
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              width: "500px",
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default AllStoresPage;
